module.exports = __webpack_public_path__ + "static/media/ic-calendar.fdf90e33.svg";